<ng-container *ngIf="!env.USE_TAILWIND">
    <div class="v4-header__mobile-menu" [ngClass]="{ 'v4-header--mobile-menu-open': mobileMenuOpen }" cdkTrapFocus>
        <div class="v4-header__mobile-header">
            <div class="v4-header__mobile-header__col-brand">
                <a [routerLink]="'/home' | localize">
                    <img
                        class="v4-header__mobile-header__col-brand__img-blue hide-for-wcag"
                        alt=""
                        src="{{ assetsPath$ | async }}/logo-open-mobile-menu.png"
                        attr.alt="{{ 'LOGO_MOBILE_ARIA_LABEL' | translate }}" />

                    <img
                        class="v4-header__mobile-header__col-brand__img-blue show-high-contrast-view"
                        alt=""
                        src="{{ assetsPath$ | async }}/logo-open-mobile-menu-wcag.png"
                        attr.alt="{{ 'LOGO_MOBILE_ARIA_LABEL' | translate }}" />
                </a>
            </div>

            <div class="v4-header__mobile-header__col-info-links">
                <div class="v4-header__mobile-header__info burguer">
                    <div class="shopping-cart">
                        <gl-header-shopping-cart (click)="closeMobileMenu()"></gl-header-shopping-cart>
                        <gl-header-shopping-cart-countdown-timer-visual></gl-header-shopping-cart-countdown-timer-visual>
                    </div>

                    <div class="v4-header__info-link-burger">
                        <span
                            class="v4-header__info-icon icon v4-header__mobile-menu-icon"
                            (click)="toggleMobileMenu()"
                            (keydown.enter)="toggleMobileMenu()"
                            (keydown.space)="toggleMobileMenu()"
                            attr.aria-expanded="{{ mobileMenuOpen }}"
                            tabindex="0"
                            role="button"
                            attr.aria-label="{{ 'CLOSE_NAVIGATION_ARIA_LABEL' | translate }}"></span>
                    </div>
                </div>
            </div>
        </div>

        <nav class="v4-header__navigation">
            <ul>
                <li *ngIf="helperService.isAllowedPath('/purchase/ticket')">
                    <div class="v4-header__mobile-entry first">
                        <a
                            class="main-category"
                            #link1="routerLinkActive"
                            #menuItem
                            [attr.aria-current]="link1.isActive ? 'page' : null"
                            [routerLink]="'/purchase/ticket' | localize"
                            (click)="closeMobileMenu()"
                            routerLinkActive="selected">
                            {{ 'HEADER_PERIOD_TICKETS' | translate }}
                        </a>
                    </div>
                </li>

                <li *ngIf="helperService.isAllowedPath('/purchase/wallet')">
                    <div class="v4-header__mobile-entry">
                        <a
                            class="main-category"
                            #link2="routerLinkActive"
                            #menuItem
                            [attr.aria-current]="link2.isActive ? 'page' : null"
                            [routerLink]="'/purchase/wallet' | localize"
                            (click)="closeMobileMenu()"
                            routerLinkActive="selected">
                            {{ 'HEADER_ADD_MONEY' | translate }}
                        </a>
                    </div>
                </li>
                <li *ngIf="helperService.isAllowedPath('/personalize')">
                    <div class="v4-header__mobile-entry">
                        <span class="main-category">{{ 'HEADER_PERSONALIZE' | translate }}</span>
                        <ul>
                            <li>
                                <a
                                    class="sub-category"
                                    #personalizeLink="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="personalizeLink.isActive ? 'page' : null"
                                    [routerLink]="'/personalize/travelcard' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'SUB_HEADER_PERSONALIZE' | translate }}
                                </a>
                            </li>
                            <li>
                                <a
                                    class="sub-category"
                                    #isicCardActivationLink="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="isicCardActivationLink.isActive ? 'page' : null"
                                    [routerLink]="'/personalize/isic-card' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'HEADER_ISIC_CARD_ACTIVATION' | translate }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>

                <li *ngIf="helperService.isAllowedPath('/bankcard-tickets')">
                    <div class="v4-header__mobile-entry">
                        <a
                            class="main-category"
                            #bankcardTicketsLink="routerLinkActive"
                            [attr.aria-current]="bankcardTicketsLink.isActive ? 'page' : null"
                            [routerLink]="'/bankcard-tickets' | localize"
                            (click)="closeMobileMenu()"
                            routerLinkActive="selected">
                            {{ 'HEADER_BANKCARD_TICKETS' | translate }}
                        </a>
                    </div>
                </li>

                <li *ngIf="helperService.isAllowedPath('/schedule')">
                    <div class="v4-header__mobile-entry">
                        <a
                            class="main-category"
                            #scheduleLink="routerLinkActive"
                            #menuItem
                            [attr.aria-current]="scheduleLink.isActive ? 'page' : null"
                            [routerLink]="'/schedule' | localize"
                            (click)="closeMobileMenu()"
                            routerLinkActive="selected">
                            {{ 'HEADER_MAP' | translate }}
                        </a>
                    </div>
                </li>

                <li *ngIf="env.ONDEMAND?.SHOW_LINKS && showBookARide">
                    <div class="v4-header__mobile-entry">
                        <a
                            class="main-category"
                            #scheduleLink="routerLinkActive"
                            #menuItem
                            [attr.aria-current]="scheduleLink.isActive ? 'page' : null"
                            [routerLink]="'/book-a-ride' | localize"
                            (click)="closeMobileMenu()"
                            routerLinkActive="selected">
                            {{ 'HEADER_BOOK_RIDE' | translate }}
                        </a>
                    </div>
                </li>

                <li *ngIf="env.ONDEMAND?.SHOW_LINKS && helperService.isAllowedPath('/ondemand-trips')">
                    <div class="v4-header__mobile-entry">
                        <a
                            class="main-category"
                            #scheduleLink="routerLinkActive"
                            #menuItem
                            [attr.aria-current]="scheduleLink.isActive ? 'page' : null"
                            [routerLink]="'/ondemand-trips' | localize"
                            (click)="closeMobileMenu()"
                            routerLinkActive="selected">
                            {{ 'HEADER_ONDEMAND_TRIPS' | translate }}
                        </a>
                    </div>
                </li>

                <li>
                    <div class="v4-header__mobile-entry">
                        <span class="main-category">{{ 'AUTH_TEXT_TITLE_MY_ACCOUNT' | translate }}</span>

                        <ul>
                            <li
                                *ngIf="
                                    ridangoAuth.getLoginStatus() &&
                                    helperService.isAllowedPath('/account/related-cards')
                                ">
                                <a
                                    class="sub-category account log-out"
                                    #link3="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link3.isActive ? 'page' : null"
                                    [routerLink]="'/account/related-cards' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_CARDS_ACTIVE_TICKETS' | translate }}
                                </a>
                            </li>

                            <li
                                *ngIf="
                                    ridangoAuth.getLoginStatus() &&
                                    helperService.isAllowedPath('/account/purchase-history')
                                ">
                                <a
                                    class="sub-category account log-out"
                                    #link4="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link4.isActive ? 'page' : null"
                                    [routerLink]="'/account/purchase-history' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_PURCHASE_HISTORY' | translate }}
                                </a>
                            </li>

                            <li
                                *ngIf="
                                    ridangoAuth.getLoginStatus() &&
                                    helperService.isAllowedPath('/account/validation-history')
                                ">
                                <a
                                    class="sub-category account log-out"
                                    #link5="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link5.isActive ? 'page' : null"
                                    [routerLink]="'/account/validation-history' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_VALIDATION_HISTORY' | translate }}
                                </a>
                            </li>

                            <li *ngIf="ridangoAuth.getLoginStatus() && helperService.isAllowedPath('/seutulippu')">
                                <a
                                    class="sub-category account log-out"
                                    #link6="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link6.isActive ? 'page' : null"
                                    [routerLink]="'/account/seutulippu' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_SEUTULIPPU' | translate }}
                                </a>
                            </li>

                            <li
                                *ngIf="
                                    ridangoAuth.getLoginStatus() &&
                                    helperService.isAllowedPath('/account/bookings') &&
                                    showBookARide
                                ">
                                <a
                                    class="sub-category account log-out"
                                    #link7="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link7.isActive ? 'page' : null"
                                    [routerLink]="'/account/bookings' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_BOOKINGS' | translate }}
                                </a>
                            </li>

                            <li
                                *ngIf="
                                    ridangoAuth.getLoginStatus() &&
                                    helperService.isAllowedPath('/account/ride-history') &&
                                    showBookARide
                                ">
                                <a
                                    class="sub-category account log-out"
                                    #link8="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link8.isActive ? 'page' : null"
                                    [routerLink]="'/account/ride-history' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_RIDE_HISTORY' | translate }}
                                </a>
                            </li>

                            <li
                                *ngIf="
                                    ridangoAuth.getLoginStatus() &&
                                    helperService.isAllowedPath('/account/notification-settings')
                                ">
                                <a
                                    class="sub-category account log-out"
                                    #link11="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link11.isActive ? 'page' : null"
                                    [routerLink]="'/account/notification-settings' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_NOTIFICATION_SETTINGS' | translate }}
                                </a>
                            </li>

                            <li *ngIf="ridangoAuth.getLoginStatus() && helperService.isAllowedPath('/profile')">
                                <a
                                    class="sub-category account log-out"
                                    #link9="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link9.isActive ? 'page' : null"
                                    [routerLink]="'/account/profile' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MY_ACCOUNT_PROFILE' | translate }}
                                </a>
                            </li>

                            <li *ngIf="!ridangoAuth.getLoginStatus() && helperService.isAllowedPath('/login')">
                                <a
                                    class="sub-category account"
                                    #link10="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link10.isActive ? 'page' : null"
                                    [routerLink]="'/login' | localize"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MOBILE_NAV_LOGIN' | translate }}
                                </a>
                                <button
                                    class="sub-category account"
                                    #link10="routerLinkActive"
                                    #menuItem
                                    [attr.aria-current]="link10.isActive ? 'page' : null"
                                    (click)="closeMobileMenu()"
                                    routerLinkActive="selected">
                                    {{ 'MOBILE_NAV_LOGIN' | translate }}
                                </button>
                            </li>

                            <li *ngIf="ridangoAuth.getLoginStatus() && helperService.isAllowedPath('/login')">
                                <a
                                    class="sub-category last log-out"
                                    #menuItem
                                    (click)="logout()"
                                    (keydown.enter)="logout()"
                                    (keydown.space)="logout()"
                                    role="button"
                                    tabindex="0">
                                    {{ 'MOBILE_NAV_LOGOUT' | translate }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>

                <li *ngIf="env.REGION_ID === !(128 || 6)">
                    <div class="v4-header__mobile-entry">
                        <a class="main-category" href="https://www.gotland.se/kollektivtrafiken" target="_blank">
                            {{ 'ABOUT' | translate }}
                        </a>
                    </div>
                </li>

                <li>
                    <div class="v4-header__mobile-entry">
                        <span class="main-category">{{ 'HELP_CENTER' | translate }}</span>

                        <ul>
                            <li>
                                <div class="specific-link sub-category">
                                    <span class="icon icon-mail"></span>
                                    <a
                                        (click)="closeMobileMenu()"
                                        href="{{ 'MAIL_AT_LINK' | translate }}"
                                        target="_blank">
                                        {{ 'MAIL_AT' | translate }}
                                    </a>
                                </div>
                            </li>

                            <li>
                                <div class="specific-link sub-category">
                                    <span class="icon icon-call"></span>
                                    <a
                                        href="{{ 'FOOTER_PHONE_LINK' | translate }}"
                                        attr.aria-label="{{ 'FOOTER_CALL_US' | translate }}">
                                        {{ 'FOOTER_PHONE_TEXT' | translate }}
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>

                <li>
                    <div class="v4-header__mobile-entry">
                        <a
                            class="main-category"
                            #link11="routerLinkActive"
                            #menuItem
                            [attr.aria-current]="link11.isActive ? 'page' : null"
                            [routerLink]="'/terms-and-conditions' | localize"
                            (click)="closeMobileMenu()"
                            routerLinkActive="selected">
                            {{ 'MOBILE_MENU_TERSM_AND_CONDITIONS' | translate }}
                        </a>
                    </div>
                </li>
                <li *ngIf="!env.HEADER.HIDE_LANGUAGE_SELECTOR">
                    <div class="v4-header__mobile-entry last">
                        <span class="main-category">{{ 'LANGUAGE' | translate }}</span>

                        <ul>
                            <li *ngFor="let language of languages$ | async">
                                <a
                                    class="sub-category pn-light:text-white"
                                    [attr.aria-current]="language.code === (selectedLanguage$ | async)?.code"
                                    [ngClass]="{ selected: language.code === (selectedLanguage$ | async)?.code }"
                                    (click)="languageChanged(language)"
                                    (keydown.enter)="languageChanged(language)"
                                    (keydown.space)="languageChanged(language)"
                                    tabindex="0"
                                    role="button">
                                    {{ language.name }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </nav>
    </div>
</ng-container>

<ng-container *ngIf="env.USE_TAILWIND && !env.SHOW_NEW_MOBILE_MENU">
    <div
        class="left-0 z-[5] w-full bg-white p-4 pt-0"
        [ngClass]="{
            'fixed h-screen': !env.IS_MOBILE_APP,
            'block overflow-y-auto': mobileMenuOpen,
            'container-mobile-menu fixed h-full': env.IS_MOBILE_APP
        }"
        cdkTrapFocus>
        <nav class="mb-[var(--ion-safe-area-bottom)] pb-36">
            <ul class="flex flex-col">
                <li class="flex items-center">
                    <div class="flex h-14 w-full items-center">
                        <div class="flex flex-1 items-center pr-2">
                            <mat-icon class="mr-1 text-[1rem] text-secondary">accessibility_new</mat-icon>
                            <button
                                class="p-1 text-sm text-secondary dark:text-contrast-yellow"
                                (click)="toggleContrast()"
                                (keydown.enter)="toggleContrast()"
                                (keydown.space)="toggleContrast()"
                                tabindex="0">
                                <span *ngIf="!isContrast">{{ 'HEADER_ACCESSIBILITY_CONTRAST_TEXT' | translate }}</span>
                                <span *ngIf="isContrast">
                                    {{ 'HEADER_ACCESSIBILITY_NORMAL_CONTRAST_TEXT' | translate }}
                                </span>
                            </button>
                        </div>

                        <ul class="login-section flex items-center">
                            <li
                                class="relative flex items-center justify-center"
                                *ngIf="helperService.isAllowedPath('/register')">
                                <mat-icon class="mr-1 text-[1rem]">account_circle</mat-icon>
                                <a
                                    class="pr-3 text-sm"
                                    *ngIf="!ridangoAuth.getLoginStatus()"
                                    [routerLink]="'/register' | localize"
                                    (click)="closeMobileMenu()">
                                    {{ 'HEADER_SECONDARY_NAV_REGISTER' | translate }}
                                </a>

                                <a
                                    class="max-w-[8rem] overflow-hidden text-ellipsis whitespace-nowrap pr-3 text-sm"
                                    *ngIf="ridangoAuth.getLoginStatus()"
                                    [routerLink]="
                                        env?.PURCHASE_FLOW?.PREFERENCES_OLD_ADD_TRAVEL_CARD_LINK
                                            ? ('/account/related-cards' | localize)
                                            : ('/account/cards' | localize)
                                    "
                                    (click)="closeMobileMenu()">
                                    {{ loggedInCustomer }}
                                </a>
                            </li>

                            <li class="flex items-center justify-center" *ngIf="helperService.isAllowedPath('/login')">
                                <a
                                    class="pl-3 text-sm"
                                    *ngIf="!ridangoAuth.getLoginStatus()"
                                    [routerLink]="'/login' | localize"
                                    (click)="closeMobileMenu()">
                                    {{ 'HEADER_SECONDARY_NAV_LOGIN' | translate }}
                                </a>
                                <button
                                    class="pl-3 text-sm text-secondary dark:text-contrast-yellow"
                                    *ngIf="ridangoAuth.getLoginStatus()"
                                    (click)="logout()"
                                    (keydown.enter)="logout()">
                                    {{ 'MAIN_MENU_LOGOUT' | translate }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </li>
                <ng-container>
                    <ng-container *ngIf="(useDropdownMenuSystem$ | async) === false">
                        <ng-container *ngFor="let headerElement of menuItems">
                            <ng-container *ngIf="!headerElement.subPaths; else subPaths">
                                <li *ngIf="isMenuItemAllowed(headerElement)">
                                    <div
                                        class="flex h-14 items-center border-b-2 border-solid border-[#EFF0F2] dark:border-contrast-yellow">
                                        <!-- External link -->
                                        <button
                                            class="text-xl text-secondary"
                                            *ngIf="headerElement.isExternal; else internalLink"
                                            (click)="handleExternalLink(headerElement.externalUrl)"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            {{ headerElement.label | translate }}
                                        </button>

                                        <!-- Internal link -->
                                        <ng-template #internalLink>
                                            <a
                                                class="text-xl text-secondary"
                                                #link="routerLinkActive"
                                                [attr.aria-current]="link.isActive ? 'page' : null"
                                                [routerLink]="headerElement.path | localize"
                                                (click)="closeMobileMenu()"
                                                routerLinkActive="!text-primary">
                                                {{ headerElement.label | translate }}
                                            </a>
                                        </ng-template>
                                    </div>
                                </li>
                            </ng-container>

                            <ng-template #subPaths>
                                <li *ngIf="isMenuItemAllowed(headerElement)">
                                    <div
                                        class="border-b-2 border-solid border-[#EFF0F2] py-3 dark:border-contrast-yellow">
                                        <span class="block pb-3 text-xl text-secondary dark:text-contrast-yellow">{{
                                            headerElement.label | translate
                                        }}</span>
                                        <ul class="pl-3">
                                            <ng-container *ngFor="let subHeaderElement of headerElement.subPaths">
                                                <li class="py-3" *ngIf="isMenuItemAllowed(subHeaderElement)">
                                                    <a
                                                        class="sub-category"
                                                        #subLink="routerLinkActive"
                                                        [ngClass]="subLink.isActive ? 'text-primary' : 'text-secondary'"
                                                        [routerLink]="subHeaderElement.path | localize"
                                                        (click)="closeMobileMenu()"
                                                        routerLinkActive="selected">
                                                        {{ subHeaderElement.label | translate }}
                                                    </a>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </li>
                            </ng-template>
                        </ng-container>
                    </ng-container>

                    <!--New menu with dropdowns-->
                    <ng-container *ngIf="(useDropdownMenuSystem$ | async) === true">
                        <ng-container *ngFor="let menuItem of filteredDropdownMenuItems$ | async; let last = last">
                            <div class="h-px w-full bg-grey-white_smoke dark:bg-contrast-yellow"></div>

                            <li class="w-full">
                                <ng-container *ngIf="!menuItem.hasDropdown">
                                    <a
                                        class="hu-light:text-primary dropdown-menu-button block w-full px-6 py-4 text-left"
                                        *ngIf="!menuItem.isExternal"
                                        [routerLink]="menuItem.path | localize">
                                        {{ menuItem.label | translate }}
                                    </a>

                                    <a
                                        class="hu-light:text-primary dropdown-menu-button block w-full px-6 py-4 text-left"
                                        *ngIf="menuItem.isExternal"
                                        [href]="menuItem.path | translate">
                                        {{ menuItem.label | translate }}
                                    </a>
                                </ng-container>

                                <button
                                    class="hu-light:text-primary dropdown-menu-button flex w-full items-center justify-between px-6 py-4 text-left"
                                    *ngIf="menuItem.hasDropdown"
                                    [class.menu-open]="isMobileMenuOpen(menuItem.menuId) | async"
                                    (click)="toggleMobileDropdown(menuItem.menuId)">
                                    <span>{{ menuItem.label | translate }}</span>
                                    <span
                                        class="dropdown-arrow -mt-0.5 ml-1 inline-block h-1.5 w-1.5 rotate-45 align-middle transition-transform duration-200"></span>
                                </button>

                                <gl-mobile-dropdown-menu
                                    *ngIf="menuItem.hasDropdown"
                                    [isVisible]="isMobileMenuOpen(menuItem.menuId) | async"
                                    [menuData]="(dropdownMenuData$ | async)?.[menuItem.menuId]">
                                </gl-mobile-dropdown-menu>
                            </li>

                            <div class="h-px w-full bg-grey-white_smoke dark:bg-contrast-yellow" *ngIf="last"></div>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <li *ngIf="!env.HEADER.HIDE_LANGUAGE_SELECTOR && env.IS_MOBILE_APP">
                    <div class="border-b-2 border-solid border-[#EFF0F2] py-3 dark:border-contrast-yellow">
                        <span class="block pb-3 text-xl text-secondary dark:text-contrast-yellow">
                            {{ 'LANGUAGE' | translate }}
                        </span>

                        <ul class="pl-3">
                            <li class="py-3" *ngFor="let language of languages$ | async">
                                <a
                                    [ngClass]="{ 'text-primary': language.code === (selectedLanguage$ | async)?.code }"
                                    [attr.aria-current]="language.code === (selectedLanguage$ | async)?.code"
                                    (click)="languageChanged(language)"
                                    (keydown.enter)="languageChanged(language)"
                                    (keydown.space)="languageChanged(language)">
                                    {{ language.name }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>

            <div class="mt-3">
                <h2 class="bold mb-3 flex text-base">{{ 'HELP_CENTER' | translate }}</h2>
                <div class="flex flex-col">
                    <div class="flex items-center">
                        <mat-icon class="mr-2 text-[1rem]">mail</mat-icon>
                        <a href="{{ 'MAIL_AT_LINK' | translate }}" target="_blank">
                            {{ 'HEADER_MAIL_US' | translate }}
                        </a>
                    </div>

                    <div class="mb-2 flex items-center">
                        <mat-icon class="mr-2 text-[1rem]">call</mat-icon>
                        <a
                            class="text-secondary dark:text-contrast-yellow"
                            [href]="'tel:' + ('FOOTER_PHONE_LINK' | translate)">
                            {{ 'FOOTER_PHONE_TEXT' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</ng-container>

<ng-container *ngIf="env.USE_TAILWIND && env.SHOW_NEW_MOBILE_MENU">
    <gl-mobile-menu-wrapper
        [mobileMenuOpen]="mobileMenuOpen"
        [isContrast]="isContrast"
        [loggedInCustomer]="loggedInCustomer"
        [trapFocus]="trapFocus"
        (didToggleMobileMenu)="toggleMobileMenu()"
        (didCloseMobileMenu)="closeMobileMenu()"
        (didLogOut)="logout()"
        (didLanguageChange)="didLanguageChange.emit($event)"
        (themeToggle)="toggleContrast()"></gl-mobile-menu-wrapper>
</ng-container>
